import api from './axios';

export const login    = (email, senha) => api.post('/auth/login', { email, senha }).then(r => r.data);
export const logout   = ()             => api.post('/auth/logout').then(r => r.data);
export const getMe    = ()             => api.get('/auth/me').then(r => r.data);
export const updateMe = (data)         => api.patch('/auth/me', data).then(r => r.data);
